import React, {
  useState,
  useEffect,
  useCallback,
  FunctionComponent,
} from 'react';
import {connectRefinementList} from 'react-instantsearch-dom';
import {RefinementListProvided} from 'react-instantsearch-core';
import DoubleLabeledGenericToggleSwitch from '../DoubleLabeledGenericToggleSwitch';

interface Props extends RefinementListProvided {
  labelLeft?: string,
  labelRight?: string,
  labelLeftClass?: string,
  labelRightClass?: string,
  containerClass?: string,
  id: string,
  attribute: string,
  toggleCallback?: (checked: boolean) => any,
  flipToggleDirection?: boolean,
  checked: boolean,
  setChecked: (checked: boolean) => void,
}

const ToggleSwitch: FunctionComponent<Props> = ({
labelLeft,
labelRight,
id,
toggleCallback,
refine,
flipToggleDirection,
checked,
setChecked,
labelLeftClass,
labelRightClass,
containerClass,
}) => {
  const onChangeCallback = useCallback((isChecked) => {
    // If toggle direction is flipped, this means that "checked" should refine as "false"
    const checkedIsTrue: boolean = !flipToggleDirection;
    if (isChecked) {
      refine(checkedIsTrue ? ['true'] : ['false']);
    } else {
      refine(checkedIsTrue ? ['false'] : ['true']);
    }
  }, [flipToggleDirection]);

  useEffect(() => {
    onChangeCallback(checked);
    if (toggleCallback) {
      toggleCallback(checked);
    }
  }, [checked]);

  return (
    <DoubleLabeledGenericToggleSwitch
      id={id}
      checked={checked}
      labelLeft={labelLeft}
      labelRight={labelRight}
      setChecked={setChecked}
      labelLeftClass={`d-block font-weight-bold mb-0 ${labelLeftClass}`}
      labelRightClass={`d-block font-weight-bold mb-0 ${labelRightClass}`}
      containerClass={containerClass}
    />
  );
};

export default connectRefinementList(ToggleSwitch);
